import axios from 'axios'
import { ElMessage } from 'element-plus'

const api = axios.create({
  baseURL: '/api',
  timeout: 120000,  // 2分钟超时，给生图留足时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // FormData 上传时让浏览器自动设置 Content-Type（含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
      delete config.headers['content-type']
    }
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 超时错误不显示任何提示
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      return Promise.reject(error)
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    } else if (error.response?.status === 402) {
      // 余额不足
      const data = error.response.data || {}
      ElMessage({
        message: data.error || '余额不足，请联系管理员充值',
        type: 'warning',
        duration: 5000
      })
    } else if (error.response?.status === 429) {
      // 频率限制，不显示提示
      return Promise.reject(error)
    } else {
      const message = error.response?.data?.error || error.message || '请求失败'
      ElMessage.error(message)
    }
    return Promise.reject(error)
  }
)

export default api
